// extracted by mini-css-extract-plugin
export var activityContainer = "_k5-0";
export var typingIndicatorContainer = "_k5-1";
export var typingIndicatorDot = "_k5-2";
export var wave = "_k5-3";